import { INavbarEvent } from './INavbarEvent';

export { INavbarEvent };
